import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface IPortalProps {
  idElementToRender: string;
}

export class Portal extends React.Component<IPortalProps, any> {
  constructor(props: any) {
    super(props);
  }
  public render() {
    return document.getElementById(this.props.idElementToRender)
      ? ReactDOM.createPortal(
          this.props.children,
          document.getElementById(this.props.idElementToRender)
        )
      : null;
  }
}

export default Portal;
